import { FormField, getErrors, ValutaInput } from '@maia/ui';
import { ComponentProps } from 'react';
import { useFieldContext } from '../dynamic-form';

type MoneyFieldProps = Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function MoneyField(props: MoneyFieldProps) {
  const { ...rest } = props;
  const field = useFieldContext<number>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <ValutaInput
          type="text"
          value={field.state.value}
          onChange={(e) => field.setValue(e)}
        />
      }
    />
  );
}
